import { Subject } from 'rxjs';

import { Injectable } from '@angular/core';

import {
  BaseWsService,
  ParsedWebsocketMessage,
  ResourcesService,
  ToastService,
  WebsocketMessageService,
} from '@mitsubishi/core';

import { UNIT_TEMPLATE_TOPIC, UnitTemplateMessages, UnitTemplateSessionRefreshPayload } from './unit-template.messages';

@Injectable({
  providedIn: 'root',
})
export class UnitTemplateWsService extends BaseWsService {
  #sessionRefresh$ = new Subject<UnitTemplateSessionRefreshPayload>();
  sessionRefresh$ = this.#sessionRefresh$.asObservable();

  constructor(
    wsMessageService: WebsocketMessageService,
    serverResourceService: ResourcesService,
    toastService: ToastService
  ) {
    super(wsMessageService, serverResourceService, toastService);
  }

  override setTopic(unitTemplateId: string) {
    this.topic = `${UNIT_TEMPLATE_TOPIC}/${unitTemplateId}`;
  }

  override handleMessage(message: ParsedWebsocketMessage) {
    super.handleMessage(message);

    switch (message.description) {
      case UnitTemplateMessages.UnitTemplateSessionRefresh:
        this.#sessionRefresh$.next(message.payload);
        break;
    }
  }
}
